import React from 'react'
import PopUp from '../../api/components-examples/PopUP'
import { ErrorScreen } from '../../api/components-examples/Welcome/ErrorScreen'
import ProjectMain from './ProjectMain'

const CreateProjectPanel = ({
    theme,
    setFlow,
    createRecord,
    project_error,
    onResolve,
    error,
    sampleProjectJson,
    cancelProjectCreation,
    tabView,
    flowGroups,
    navigateTo,
    myProfile,
    isSubscriptionCheck,
    buyCourse,
    isLoadingUPlan,
    dispatch,
    getAvailableUserRoles,
    fetchAllgroups,
    uPCreation,
    projectCreated,
    formDialogue,
    groupLoading,
    closes,
    myUserAccountInfo,
    createProject,
    addProjectToGroup,
    inviteUsertoProject,
    wGroupCreated,
    projectFlowInfoKey,
    isAddedDone,
    isFlowActive,
    RgroupId,
    FlowTypeKey,
    showBuyCourse,
    hideShowBuyCourse,
    showBuyGroupInfo,
    checkIsAddIntrestedAddons,
    refreshGroups,
    projectCreationError,
    updateProjectCreationError,
    checkToProject
}) => {
    const da =
        sampleProjectJson.length > 0
            ? sampleProjectJson
                .filter(i => {
                    if (i.flow_id === 'blank_project') {
                        return true
                    } else if (i.flow_id !== 'blank_project' && i.released === true) {
                        return true
                    }
                    return false
                })
                .map(item => {
                    return {
                        value: item.process_flow,
                        label: item.Title,
                        ...item
                    }
                })
            : []

    const [ErrorPopUp, setErrorPopUp] = React.useState(false)

    return (
        <div className="Welcome" style={{ padding: '0px' }} data-theme={theme.action.theme}>
            {project_error && <ErrorScreen buttonText={'Okay'} onResolve={onResolve} error={error} />}

            {ErrorPopUp && (
                <PopUp
                    width={'50%'}
                    loadingCancel={true}
                    buttonLabel={'Okay'}
                    bottomButtonCancel={false}
                    onCancel={() => {
                        setErrorPopUp(false)
                    }}
                    onExecution={() => {
                        setErrorPopUp(false)
                    }}
                >
                    <h3 style={{ fontWeight: 'bold', textAlign: 'center' }} className="heading-part">
                        Please fill all fields.
                    </h3>
                </PopUp>
            )}

            <ProjectMain
                cancelProjectCreation={cancelProjectCreation}
                data={da}
                tabView={tabView}
                flowGroups={flowGroups}
                theme={theme}
                dispatch={dispatch}
                createRecord={createRecord}
                projectCreationError={projectCreationError}
                updateProjectCreationError={updateProjectCreationError}
                checkToProject={checkToProject}
                navigateTo={navigateTo}
                myProfile={myProfile}
                isSubscriptionCheck={isSubscriptionCheck}
                buyCourse={buyCourse}
                isLoadingUPlan={isLoadingUPlan}
                setFlow={setFlow}
                getAvailableUserRoles={getAvailableUserRoles}
                fetchAllgroups={fetchAllgroups}
                uPCreation={uPCreation}
                projectCreated={projectCreated}
                formDialogue={formDialogue}
                groupLoading={groupLoading}
                closes={closes}
                myUserAccountInfo={myUserAccountInfo}
                createProject={createProject}
                inviteUsertoProject={inviteUsertoProject}
                addProjectToGroup={addProjectToGroup}
                wGroupCreated={wGroupCreated}
                projectFlowInfoKey={projectFlowInfoKey}
                isAddedDone={isAddedDone}
                isFlowActive={isFlowActive}
                RgroupId={RgroupId}
                FlowTypeKey={FlowTypeKey}
                showBuyCourse={showBuyCourse}
                hideShowBuyCourse={hideShowBuyCourse}
                showBuyGroupInfo={showBuyGroupInfo}
                checkIsAddIntrestedAddons={checkIsAddIntrestedAddons}
                refreshGroups={refreshGroups}
            />
        </div>
    )
}

export default CreateProjectPanel
